// West Alabama Bee Company
// Custom product variant selection rules
// 10-frame deep and medium supers
document.addEventListener('DOMContentLoaded', function () {
  console.log('WABC variant rules loaded');
});

// Hide Foundation Type when Without Frames is selected
function updateFoundationVisibility() {
  document.querySelectorAll('variant-picker, variant-picker-component').forEach((picker) => {
    const groups = [...picker.querySelectorAll('fieldset, .product-form__input')];

    const framesGroup = groups.find((group) =>
  group.querySelector('legend')?.textContent.trim() === 'With or Without Frames'
);
const foundationGroup = groups.find((group) =>
  group.querySelector('legend')?.textContent.trim() === 'Foundation Type'
);

    if (!framesGroup || !foundationGroup) return;
    const assembledGroup = groups.find((group) =>
  group.querySelector('legend')?.textContent.trim() === 'Assembled or Unassembled'
);
const plasticFoundation = [...foundationGroup.querySelectorAll('input[type="radio"]')]
  .find((input) => input.value.trim().toLowerCase() === 'plastic foundation');

  if (!picker.dataset.wabcInitialized) {
  picker.dataset.wabcInitialized = 'true';

  if (assembledGroup && plasticFoundation) {
    const assembled = [...assembledGroup.querySelectorAll('input[type="radio"]')]
      .find((input) => input.value.trim().toLowerCase() === 'assembled');

    const withFrames = [...framesGroup.querySelectorAll('input[type="radio"]')]
      .find((input) => input.value.trim().toLowerCase() === 'with frames');

    if (assembled && withFrames && !window.location.search.includes('variant=')) {
      if (!assembled.checked) assembled.click();
      if (!withFrames.checked) withFrames.click();
      if (!plasticFoundation.checked) plasticFoundation.click();
    }
  }
}
if (assembledGroup?.querySelector('input:checked')?.value.trim().toLowerCase() === 'assembled' && framesGroup.querySelector('input:checked')?.value.trim().toLowerCase() === 'with frames' && plasticFoundation && !plasticFoundation.checked) plasticFoundation.click();
    const selected = framesGroup.querySelector('input:checked');
    const withoutFrames = selected?.value?.trim().toLowerCase() === 'without frames';

    if (!withoutFrames && plasticFoundation &&
    foundationGroup.querySelector('input:checked')?.value.trim().toLowerCase() === 'no foundation') {
  plasticFoundation.click();
}
    foundationGroup.style.display = withoutFrames ? 'none' : '';
    if (withoutFrames) {
  const noFoundation = [...foundationGroup.querySelectorAll('input[type="radio"]')]
    .find((input) => input.value.trim().toLowerCase() === 'no foundation');

  if (noFoundation && !noFoundation.checked) {
    noFoundation.click();
  }
}
  });
}

document.addEventListener('change', () => {
  setTimeout(updateFoundationVisibility, 50);
});

window.addEventListener('load', () => {
  setTimeout(updateFoundationVisibility, 300);
});
window.addEventListener('load', () => {
  if (!window.location.search.includes('variant=')) {
    setTimeout(() => {
      const picker = document.querySelector('variant-picker');
      const selected = picker?.querySelector('input[type="radio"]:checked');
      if (selected) {
        selected.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 600);
  }
});